import { Button } from 'react-bootstrap';
import { modal } from './modal/ModalEmitter';

interface Props {
  message?: string;
  variant?: string;
  children?: any;
  icon?: string;
  modalClose?: boolean;
}

const FlexAlert = ({
  message,
  icon = 'fad fa-exclamation-triangle',
  variant = 'warning',
  modalClose = false,
  children,
}: Props) => {
  return (
    <>
      <div className="text-center flex-grow-1 d-flex flex-column justify-content-center">
        <div className={`text-${variant} mb-4`}>
          <i style={{ fontSize: '100px' }} className={icon} />
        </div>
        {!!message && <h5>message</h5>}
        {children}
      </div>
      {modalClose && (
        <div className="text-right">
          <Button onClick={() => modal.close()}>Close</Button>
        </div>
      )}
    </>
  );
};

export default FlexAlert;
